import { render, staticRenderFns } from "./AvatarInterview.vue?vue&type=template&id=096f914f"
import script from "./AvatarInterview.vue?vue&type=script&lang=js"
export * from "./AvatarInterview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports